(function ($, window, document) {
    'use strict';

    var menus = [];
    var regions = [];
    var observer;
    var pending = false;
    var observerOptions = { childList: true, characterData: true, subtree: true };

    function connected(element) {
        return document.documentElement.contains(element);
    }

    function removeIds(element) {
        element.removeAttribute('id');
        var descendants = element.querySelectorAll('[id]');
        for (var index = 0; index < descendants.length; index += 1) {
            descendants[index].removeAttribute('id');
        }
        return element;
    }

    function createMobileMenu(source) {
        var nav = document.createElement('nav');
        nav.className = 'hero-banner-menu-mobile ortho-nav';
        nav.setAttribute('aria-label', source.getAttribute('aria-label') || 'Page navigation');

        var list = document.createElement('ul');
        list.className = 'main-nav main-nav-hero-banner';
        var home = document.createElement('li');
        home.className = 'mega-parent hero-banner-menu-mobile__site-home';
        var homeLink = document.createElement('a');
        homeLink.href = '/';
        homeLink.textContent = 'SVPH Home';
        home.appendChild(homeLink);
        list.appendChild(home);

        var main = source.querySelector('.hero-banner-menu__main');
        if (main) {
            var mainItem = document.createElement('li');
            mainItem.className = 'orthopaedics-home hero-banner-menu-mobile__main';
            mainItem.appendChild(removeIds(main.cloneNode(true)));
            list.appendChild(mainItem);
        }

        var items = source.querySelector('.hero-banner-menu__items');
        if (items) {
            for (var index = 0; index < items.children.length; index += 1) {
                var item = removeIds(items.children[index].cloneNode(true));
                item.classList.add('mega-parent');
                list.appendChild(item);
            }
        }
        nav.appendChild(list);

        // In-page links must release the off-canvas scroll lock before scrolling.
        nav.addEventListener('click', function (event) {
            var link = $(event.target).closest('a')[0];
            if (link && link.hash && link.host === window.location.host &&
                link.pathname === window.location.pathname && link.target !== '_blank' &&
                document.body.classList.contains('nav-open')) {
                $('#main-header .btn-nav-trigger').first().trigger('click');
            }
        });
        return nav;
    }

    function updateMobileMenus() {
        for (var index = menus.length - 1; index >= 0; index -= 1) {
            if (!connected(menus[index].source)) {
                $(menus[index].clone).remove();
                menus.splice(index, 1);
            }
        }

        var sources = document.querySelectorAll('.hero-banner-menu');
        var wrapper = document.querySelector('#main-header .nav-wrapper, .nav-wrapper');
        if (!wrapper) {
            return;
        }

        for (var sourceIndex = 0; sourceIndex < sources.length; sourceIndex += 1) {
            var source = sources[sourceIndex];
            var state = null;
            for (var menuIndex = 0; menuIndex < menus.length; menuIndex += 1) {
                if (menus[menuIndex].source === source) {
                    state = menus[menuIndex];
                    break;
                }
            }
            var signature = source.innerHTML;
            if (!state) {
                state = { source: source, clone: null, signature: null };
                menus.push(state);
            }
            if (state.signature !== signature || !state.clone || !connected(state.clone)) {
                var clone = createMobileMenu(source);
                if (state.clone && state.clone.parentNode === wrapper) {
                    wrapper.replaceChild(clone, state.clone);
                } else {
                    $(state.clone).remove();
                    wrapper.insertBefore(clone, wrapper.firstChild);
                }
                state.clone = clone;
                state.signature = signature;
            }
        }
    }

    function updateBreadcrumbs() {
        var heroRegions = document.querySelectorAll('.region--hero');
        for (var index = 0; index < heroRegions.length; index += 1) {
            var region = heroRegions[index];
            var hasMenu = !!region.querySelector('.hero-banner-menu');
            region.classList.toggle('region--hero-with-banner-menu', hasMenu);
            var state = null;
            for (var stateIndex = 0; stateIndex < regions.length; stateIndex += 1) {
                if (regions[stateIndex].region === region) {
                    state = regions[stateIndex];
                    break;
                }
            }
            if (hasMenu) {
                var breadcrumb = region.querySelector('.breadcrumb');
                if (!breadcrumb) {
                    continue;
                }
                if (!state || state.breadcrumb !== breadcrumb) {
                    if (state) {
                        $(state.marker).remove();
                        regions.splice(regions.indexOf(state), 1);
                    }
                    var marker = document.createComment('Hero banner breadcrumb position');
                    breadcrumb.parentNode.insertBefore(marker, breadcrumb);
                    state = { region: region, breadcrumb: breadcrumb, marker: marker };
                    regions.push(state);
                }
                // Keep the breadcrumb outside the CMS widget wrapper so editing or
                // removing a widget cannot remove the page's breadcrumb with it.
                if (region.lastElementChild !== breadcrumb) {
                    region.appendChild(breadcrumb);
                }
            } else if (state) {
                if (state.marker.parentNode && connected(state.breadcrumb)) {
                    state.marker.parentNode.insertBefore(state.breadcrumb, state.marker);
                }
                $(state.marker).remove();
                regions.splice(regions.indexOf(state), 1);
            }
        }
        for (var removedIndex = regions.length - 1; removedIndex >= 0; removedIndex -= 1) {
            if (!connected(regions[removedIndex].region)) {
                regions.splice(removedIndex, 1);
            }
        }
    }

    function numeric(value) {
        return parseFloat(value) || 0;
    }

    function rememberStyles(element, properties) {
        var originals = {};
        for (var index = 0; index < properties.length; index += 1) {
            originals[properties[index]] = element.style[properties[index]];
        }
        return originals;
    }

    function restoreStyles(element, originals) {
        for (var property in originals) {
            if (Object.prototype.hasOwnProperty.call(originals, property)) {
                element.style[property] = originals[property];
            }
        }
    }

    function naturalButtonSize(button, wrap) {
        var clone = removeIds(button.cloneNode(true));
        clone.setAttribute('aria-hidden', 'true');
        clone.style.cssText += ';position:absolute;visibility:hidden;pointer-events:none;' +
            'left:0;right:auto;width:max-content;min-width:0;max-width:none;flex:none;white-space:nowrap;';
        wrap.appendChild(clone);
        var width = Math.ceil(clone.getBoundingClientRect().width);
        var style = window.getComputedStyle(clone);
        // Absolute positioning resolves centering auto margins to zero, while
        // preserving fixed gaps. Flex items expose used auto margins as pixels.
        var margins = numeric(style.marginLeft) + numeric(style.marginRight);
        wrap.removeChild(clone);
        return { width: width, margins: margins };
    }

    function sizeButtons(hero) {
        var card = hero.querySelector('.title-block');
        var wrap = card && card.querySelector('.btn-inline-wrap');
        if (!wrap) {
            return;
        }
        if (!card.heroBannerOriginalStyles) {
            card.heroBannerOriginalStyles = rememberStyles(card, ['width']);
        }
        restoreStyles(card, card.heroBannerOriginalStyles);
        hero.classList.remove('hero-banner--stacked-buttons', 'hero-banner--expanded-card');

        var buttons = [];
        for (var childIndex = 0; childIndex < wrap.children.length; childIndex += 1) {
            var button = wrap.children[childIndex];
            if (!button.heroBannerOriginalStyles) {
                button.heroBannerOriginalStyles = rememberStyles(button,
                    ['minWidth', 'maxWidth', 'whiteSpace', 'paddingLeft', 'paddingRight']);
            }
            restoreStyles(button, button.heroBannerOriginalStyles);
            if (button.getBoundingClientRect().width > 0) {
                buttons.push(button);
            }
        }
        if (!buttons.length || card.getBoundingClientRect().width === 0) {
            return;
        }

        var cardStyle = window.getComputedStyle(card);
        var cardRect = card.getBoundingClientRect();
        var wrapStyle = window.getComputedStyle(wrap);
        var contentWidth = wrap.clientWidth - numeric(wrapStyle.paddingLeft) - numeric(wrapStyle.paddingRight);
        var row = $(card).closest('.row')[0] || card.parentNode;
        var maxWidth = Math.max(cardRect.width, Math.min(row.getBoundingClientRect().right - 15,
            document.documentElement.clientWidth - 15) - cardRect.left);
        var requiredWidth = 0;
        var deficits = 0;
        var naturalWidths = [];
        var fixedMargins = [];
        var baselineWidths = [];
        var widest = 0;

        for (var index = 0; index < buttons.length; index += 1) {
            var baseline = buttons[index].getBoundingClientRect().width;
            var size = naturalButtonSize(buttons[index], wrap);
            var natural = size.width;
            var margins = size.margins;
            naturalWidths.push(natural);
            fixedMargins.push(margins);
            baselineWidths.push(baseline);
            requiredWidth += natural + margins;
            deficits += Math.max(0, natural - baseline);
            widest = Math.max(widest, natural + margins);
        }

        var desktop = window.innerWidth >= 992;
        var alreadyStacked = wrapStyle.flexDirection === 'column';
        var needsStack = !alreadyStacked && buttons.length > 1 && requiredWidth > contentWidth + 1 &&
            (!desktop || cardRect.width + deficits > maxWidth + 1);
        var expandedWidth = cardRect.width;
        if (needsStack) {
            hero.classList.add('hero-banner--stacked-buttons');
            expandedWidth += Math.max(0, widest - contentWidth);
        } else if (alreadyStacked && desktop) {
            expandedWidth += Math.max(0, widest - contentWidth);
        } else if (desktop && deficits > 1) {
            expandedWidth += deficits;
        }
        expandedWidth = Math.min(Math.ceil(expandedWidth), maxWidth);
        if (expandedWidth > cardRect.width + 1) {
            var box = cardStyle.boxSizing === 'border-box' ? 0 : numeric(cardStyle.paddingLeft) +
                numeric(cardStyle.paddingRight) + numeric(cardStyle.borderLeftWidth) + numeric(cardStyle.borderRightWidth);
            card.style.width = (expandedWidth - box) + 'px';
            hero.classList.add('hero-banner--expanded-card');
        }

        var available = contentWidth + expandedWidth - cardRect.width;
        for (var buttonIndex = 0; buttonIndex < buttons.length; buttonIndex += 1) {
            var buttonWidth = naturalWidths[buttonIndex];
            var buttonMargins = needsStack ? 0 : fixedMargins[buttonIndex];
            var buttonAvailable = Math.max(0, available - buttonMargins);
            // On very narrow screens, use only the padding reduction needed to
            // keep the label on one line before allowing an unavoidable wrap.
            if (buttonWidth > buttonAvailable + 1) {
                var buttonStyle = window.getComputedStyle(buttons[buttonIndex]);
                var leftPadding = numeric(buttonStyle.paddingLeft);
                var rightPadding = numeric(buttonStyle.paddingRight);
                var leftCapacity = Math.max(0, leftPadding - 6);
                var rightCapacity = Math.max(0, rightPadding - 6);
                var reduction = Math.min(buttonWidth - buttonAvailable, leftCapacity + rightCapacity);
                var leftReduction = Math.min(leftCapacity, reduction / 2);
                var rightReduction = Math.min(rightCapacity, reduction - leftReduction);
                leftReduction += Math.min(leftCapacity - leftReduction, reduction - leftReduction - rightReduction);
                if (reduction > 0) {
                    buttons[buttonIndex].style.paddingLeft = (leftPadding - leftReduction) + 'px';
                    buttons[buttonIndex].style.paddingRight = (rightPadding - rightReduction) + 'px';
                    buttonWidth -= reduction;
                }
            }
            if (needsStack || naturalWidths[buttonIndex] > baselineWidths[buttonIndex] + 1) {
                buttons[buttonIndex].style.maxWidth = alreadyStacked ? buttonWidth + 'px' : 'none';
                buttons[buttonIndex].style.minWidth = Math.min(buttonWidth, buttonAvailable) + 'px';
            }
            // A label wider than the entire viewport may still wrap; ordinary
            // labels stay on one line without widening cards that already fit.
            buttons[buttonIndex].style.whiteSpace = buttonWidth + buttonMargins <= available + 1 ? 'nowrap' : 'normal';
        }
    }

    function refresh() {
        pending = false;
        if (observer) {
            observer.disconnect();
        }
        updateMobileMenus();
        updateBreadcrumbs();
        var heroes = document.querySelectorAll('.hero-banner');
        for (var index = 0; index < heroes.length; index += 1) {
            sizeButtons(heroes[index]);
        }
        if (observer) {
            observer.observe(document.body, observerOptions);
        }
    }

    function scheduleRefresh() {
        if (!pending) {
            pending = true;
            (window.requestAnimationFrame || window.setTimeout)(refresh);
        }
    }

    $(function () {
        refresh();
        $(window).on('resize.heroBanner load.heroBanner', scheduleRefresh);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(scheduleRefresh);
        }
        if (window.MutationObserver) {
            observer = new window.MutationObserver(function (mutations) {
                for (var index = 0; index < mutations.length; index += 1) {
                    var target = mutations[index].target;
                    if (target.nodeType !== 1) {
                        target = target.parentNode;
                    }
                    if ($(target).closest('.hero-banner, .hero-banner-menu, .region--hero').length) {
                        scheduleRefresh();
                        return;
                    }
                    var nodeGroups = [mutations[index].addedNodes, mutations[index].removedNodes];
                    for (var groupIndex = 0; groupIndex < nodeGroups.length; groupIndex += 1) {
                        var nodes = nodeGroups[groupIndex];
                        for (var nodeIndex = 0; nodeIndex < nodes.length; nodeIndex += 1) {
                            if (nodes[nodeIndex].nodeType === 1 &&
                                ($(nodes[nodeIndex]).is('.hero-banner, .hero-banner-menu, .region--hero, .nav-wrapper') ||
                                    nodes[nodeIndex].querySelector('.hero-banner, .hero-banner-menu, .region--hero, .nav-wrapper'))) {
                                scheduleRefresh();
                                return;
                            }
                        }
                    }
                }
            });
            observer.observe(document.body, observerOptions);
        }
    });
})(jQuery, window, document);
